export const getTalksUrl = (workspaceId: string, agentID: string) => `
/business/workspaces/${workspaceId}/agents/${agentID}/talks`;
